/**
 * A picked file's id on the Import files screen. A browser File has no path, so the same
 * file picked or dropped twice is recognised by its name, size and modification time.
 */
export const importFileId = (file: Pick<File, 'name' | 'size' | 'lastModified'>): string =>
  `${file.name}|${file.size}|${file.lastModified}`;
